import type {
  AuthenticateFromMagicLinkMutation,
  AuthenticateFromMagicLinkMutationVariables,
} from '@src/types/__generated/rewareRestUserTypes';
import { exec } from '../utils';

const gql = String.raw;

const AUTHENTICATE_FROM_MAGIC_LINK_QUERY = gql`
  mutation authenticateFromMagicLink(
    $token: String
    $email: String
    $code: String
  ) {
    authenticateFromMagicLink(
      token: $token
      email: $email
      code: $code
    ) {
      uuid
      name
      email
      oneTimeToken
      token
    }
  }
`;

export type MagicLinkSessionUser = NonNullable<
  AuthenticateFromMagicLinkMutation['authenticateFromMagicLink']
>;

/**
 * Exchanges a single-use magic-link credential for a dashboard session (JWT + one-time token on
 * the returned user), matching the shape returned by the badge/SSO flows. Accepts either the link
 * `token` (clicked on the requesting device) or the `email` + typed `code` (confirmation form).
 */
export const authenticateFromMagicLink = async (
  params: AuthenticateFromMagicLinkMutationVariables
): Promise<MagicLinkSessionUser> => {
  const data = await exec<AuthenticateFromMagicLinkMutationVariables, AuthenticateFromMagicLinkMutation>(
    AUTHENTICATE_FROM_MAGIC_LINK_QUERY,
    {
      variables: params,
    },
  );

  // The field is nullable in the schema, but a successful mutation always returns the user
  // (failures surface as GraphQL errors, which `exec` throws).
  const user = data.authenticateFromMagicLink;
  if (!user) {
    throw new Error('authenticateFromMagicLink returned no user');
  }

  return user;
};
